import { api } from "./client";

export type TransferRow = {
  id: string;
  filename: string;
  bytes_sent: number | null;
  status: "pending" | "running" | "sent" | "failed";
  error_message: string;
  recipient_agent: string;
  recipient_hostname: string;
  recipient_label: string;
  created_at: string;
  completed_at: string | null;
  // Present only on the create response: true when the recipient PC was
  // offline, so the file is held and delivered when it wakes.
  queued?: boolean;
};

export async function listTransfers() {
  const { data } = await api.get<{ results: TransferRow[] }>("/transfers/");
  return data;
}

// Upload a file from the dashboard to deliver to a PC's inbox. Cloud-routed:
// the bytes go to the backend, which dispatches a deliver_file task to the
// recipient. multipart/form-data.
export async function createTransfer(recipientAgentId: string, file: File) {
  const form = new FormData();
  form.append("recipient_agent_id", recipientAgentId);
  form.append("file", file);
  const { data } = await api.post<TransferRow>("/transfers/", form);
  return data;
}
